import { forwardRef, useRef } from "react"
import { TextFieldProps, useTheme, alpha, Box } from "@mui/material"
import { FilterTextField } from "./FilterTextField"
import { motion } from "framer-motion"

export interface FilterFieldProps extends Omit<TextFieldProps, "onChange" | "onSubmit"> {
	isEditing: bool
	value?: string
	onChange?: (value: string) => void
	onEdit?: () => void
	onSubmit?: (value: string) => void
}



export const FilterField = forwardRef<HTMLDivElement, FilterFieldProps>(
	({ isEditing, value, onChange, onEdit, onSubmit, ...textFieldProps }, ref) => {
		const inputRef = useRef<HTMLInputElement>(null)
		if (isEditing) {
			// use default value
			return (
				<Box
					component={motion.div}
					initial="initial"
					animate="animate"
					exit="exit"
					whileHover="hover"
					style={{ width: "100%" }}
				>
					<FilterTextField
						ref={ref}
						defaultValue={value}
						size="small"
						onChange={(e) => onChange?.(e.target.value)}
						onBlur={(e) => onSubmit?.(e.target.value)}
						inputRef={inputRef}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault()
								const inputValue = (e.target as HTMLInputElement).value
								onSubmit?.(inputValue)
								//clear focus
								inputRef.current?.blur()
							}
							e.stopPropagation()
						}}
						onClick={(e) => e.stopPropagation()}
						autoFocus
						fullWidth
						{...textFieldProps}
					/>
				</Box>
			)
		}

		// set the value here
		return (
			<Box
				component={motion.div}
				initial="initial"
				animate="animate"
				exit="exit"
				whileHover="hover"
				whileTap="tap"
				style={{ width: "100%" }}
			>
				<FilterTextField
					{...textFieldProps}
					size="small"
					value={value}
					fullWidth
					InputProps={{
						readOnly: true,
					}}
					onClick={(e) => {
						e.stopPropagation()
						onEdit?.()
					}}
				/>
			</Box>
		)
	}
)

FilterField.displayName = "FilterField"
